import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"check-circle\"><g clip-path=\"url(#check-circle_clip0)\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M14.667 8.105v.613a6.666 6.666 0 11-3.954-6.093\" /><path d=\"M14.667 3.385L8 10.058l-2-2\" /></g><defs><clipPath id=\"check-circle_clip0\"><path d=\"M0 .718h16v16H0v-16z\" fill=\"#fff\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol